export async function fetchUrl(url) {
  const data = await (await fetch(url, { credentials: "include" })).json();

  return data;
}
